// Single source of truth for the version displayed in the app footer, Trust page
// and (via /api/) the backend health payload. Bump on every production release.
export const APP_VERSION = "1.4.2";
export const BUILD_DATE = "2026-02-27";
